<template>
  <div
    class="subscription-cycle-radio"
    :class="{disabled: disabled}"
  >
    <div class="subscription-cycle-title text-secondary">
      {{ $t('payment.billing-cycle') }}
    </div>
    <b-row>
      <b-col
        id="annually-cycle-radio"
        sm="12"
        md="6"
      >
        <div
          class="cycle-radio"
          :class="{active: value === 'yearly'}"
          @click="disabled ? null : $emit('input', 'yearly')"
        >
          <div class="cycle-radio-icon">
            <feather-icon
              icon="CircleIcon"
              size="16"
              :class="{'text-primary': value === 'yearly'}"
            />
          </div>
          <div class="cycle-radio-text">
            <div class="font-weight-semi-bold">
              {{ $t('payment.annually') }} - {{ $currencyFormat(yearlyPrice / 12, 0) }} {{ $t('payment.per-month') }}
            </div>
            <div class="font-weight-semi-bold">
              {{ $t('payment.total') }}: {{ $currencyFormat(totalYearlyPrice, 0) }}
              <template v-if="totalYearlyPrice !== yearlyPrice">
                ({{ yearlyPrice }} + {{ totalYearlyPrice - yearlyPrice }})
              </template>
            </div>
          </div>
        </div>
        <div class="cycle-period">
          {{ $t('fields.from') }}:
          <span class="font-weight-bold">{{ startFrom }}</span>
          - {{ $t('fields.to') }}:
          <span class="font-weight-bold">{{ yearlyTo }}</span>
        </div>
      </b-col>

      <b-col
        sm="12"
        md="6"
      >
        <div
          class="cycle-radio"
          :class="{active: value === 'monthly'}"
          @click="disabled ? null : $emit('input', 'monthly')"
        >
          <div class="cycle-radio-icon">
            <feather-icon
              icon="CircleIcon"
              size="16"
              :class="{'text-primary': value === 'monthly'}"
            />
          </div>
          <div class="cycle-radio-text">
            <div class="font-weight-semi-bold">
              {{ $t('payment.monthly') }} - {{ $currencyFormat(monthlyPrice, 0) }} {{ $t('payment.per-month') }}
            </div>
            <div class="font-weight-semi-bold">
              {{ $t('payment.total') }}: {{ $currencyFormat(totalMonthlyPrice, 0) }}
              <template v-if="totalMonthlyPrice !== monthlyPrice">
                ({{ monthlyPrice }} + {{ totalMonthlyPrice - monthlyPrice }})
              </template>
            </div>
          </div>
        </div>
        <div class="cycle-period">
          {{ $t('fields.from') }}:
          <span class="font-weight-bold">{{ startFrom }}</span>
          - {{ $t('fields.to') }}:
          <span class="font-weight-bold">{{ monthlyTo }}</span>
        </div>
      </b-col>
    </b-row>

    <can-get-extra-free-tooltip
      v-if="canGetExtraFree"
      placement="bottom"
      target="annually-cycle-radio"
    />
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import CanGetExtraFreeTooltip from '@/views/admin/purchase/components/CanGetExtraFreeTooltip'

export default {
  name: 'SubscriptionCycleRadio',
  components: {
    CanGetExtraFreeTooltip,
    BRow,
    BCol,
  },
  props: {
    value: {
      type: String,
      default: 'yearly',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      monthlyPrice: 'purchase/monthlyPrice',
      totalMonthlyPrice: 'purchase/totalMonthlyPrice',
      yearlyPrice: 'purchase/yearlyPrice',
      totalYearlyPrice: 'purchase/totalYearlyPrice',
      canGetExtraFree: 'purchase/canGetExtraFree',
    }),
    startFrom() {
      return this.$moment().format('DD/MM/YYYY')
    },
    yearlyTo() {
      return this.$moment().add(12 + (this.canGetExtraFree ? 2 : 0), 'months').format('DD/MM/YYYY')
    },
    monthlyTo() {
      return this.$moment().add(1, 'month').format('DD/MM/YYYY')
    },
  },
}
</script>

<style lang="scss">
.subscription-cycle-radio {
  .subscription-cycle-title {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 20px;
  }

  .cycle-period {
    text-align: center;
    color: var(--secondary);
    margin: 9px 0;
    font-size: 14px;
    font-weight: 500;

    body.dark-layout & {
      color: #ffffff;
    }
  }

  .cycle-radio {
    display: flex;
    padding: 27px 30px 25px;
    border-radius: 5px;
    border: solid 1px #efefef;
    background-color: #fafafa;
    cursor: pointer;

    body.dark-layout & {
      background-color: var(--theme-dark-body-bg);
    }

    &.active {
      border-color: #FF055D;

      .feather.feather-circle {
        fill: #FF055D;
        filter: drop-shadow(0 0 15px rgb(252, 200, 82));
      }
    }

    .cycle-radio-icon {
      margin: 0 10px;
    }

    .cycle-radio-text {
      flex-grow: 1;
    }
  }

  &.disabled {
    .cycle-radio {
      cursor: not-allowed;

      &:not(.active) {
        opacity: 0.6;
      }
    }
  }
}
</style>
